import { Roles, BackOfficeRoles } from 'types';

// PAYROLL DASHBOARD (PAYROLL-DASHBOARD-PLAN.md §17, approved 26 Oct 2026).
// Every owner switch is one line here, mirrored from the backend's
// clix-shared/services/payrollDashboard/definitions.js. The owner confirms or
// changes Q6/Q7/Q8/Q11 in the morning: change the line here and there.

// --- Owner switches (§14 / §17) ----------------------------------------------

/** Q6: the row's "Sales" (owner 29 Oct; was "Earnings") = the rep's
 * allocated sales (engine netSalesTotal of shows overlapping the range),
 * not totalPay (WP-03). */
export const EARNINGS_FIELD = 'netSalesTotal' as const;

/** Q7: Advances "Remaining / Outstanding / Repaid" has no approved
 * definition: the API sends null and the region stays masked (CDR PR-21). */
export const ADVANCES_OUTSTANDING = null;

/** Q8: Salary Chart total = Σ totalPayout (= Profile "Total salary"). */
export const SALARY_CHART_TOTAL_FIELD = 'totalPayout' as const;

/** Q11: (a) Partial-approve reason, (b) Paycheck notes. Recommended yes, but
 * both change today's request bodies, so neither is wired in this build
 * (CDR PR-24 / PR-25 stay masked). */
export const Q11_FLAGS = Object.freeze({
  paycheckNotes: true,
  partialReason: true,
  wiredInThisBuild: false,
});

// --- Who may open /payroll (§5, §17 Q4) --------------------------------------

/** Company Owner, Administrative and Accounting read every tab. */
export const VIEWER_ROLES: readonly string[] = Object.freeze([
  Roles.COMPANY_OWNER,
  BackOfficeRoles.ADMINISTRATIVE,
  BackOfficeRoles.ACCOUNTING,
]);

/** The Ops 403 text (the page shows it as sent). */
export const FORBIDDEN_MESSAGE = 'Payroll is not available for your role';

// --- Bounds (the Ops API contract) -------------------------------------------

export const MAX_RANGE_MONTHS = 13;
export const MAX_LIMIT = 50;
export const TREND_MONTHS = 24;

/** Rows per page as drawn: 6 on the desktop table ("Showing 1 — 6 of 12"),
 * 5 on the iPhone list ("Showing 1 — 5 of 42"). Both are ≤ MAX_LIMIT. */
export const PAGE_SIZE = Object.freeze({ phone: 5, desktop: 6 });

// --- Live data (PAYROLL-LIVE-SAAS-PLAN, 27 Oct 2026) -------------------------

/** Summary poll while the page is visible (Ops reads live; no refresh). */
export const SUMMARY_POLL_MS = 60 * 1000;

/** While a show sells the summary polls every 5 minutes (and on focus), so
 * a page left open learns that selling ended (round 3, 27 Oct 2026). */
export const SELLING_POLL_MS = 5 * 60 * 1000;

export const summaryPollMs = (sellingNow: boolean) =>
  sellingNow ? SELLING_POLL_MS : SUMMARY_POLL_MS;
